
    <div class="flex flex-column align-items-center mb-4">
        <span
            class="flex align-items-center justify-content-center bg-pink-100 text-pink-800 border-circle mb-3"
            style="width: 64px; height: 64px;"><i class="fa-regular fa-id-card text-5xl"></i></span>
        <div class="font-medium text-2xl text-900">Selecciona una aplicación</div>
    </div>
    <p class="line-height-3 p-0 m-0 text-justify"> Tus credenciales son correctas. Ahora tienes que seleccionar en que aplicación quieres entrar. 
        No te preocupes, podrás elegir nuevamente más adelante. </p>

    <p-divider></p-divider>
    <div class="flex justify-content-around">
        <div class="lg:w-auto w-6 px-2  py-2">
            <p-button styleClass="p-button-outlined p-button-danger w-full flex justify-content-center" (onClick)="selecApp(config.data.loginConductores)">
                <span class="text-2xl text-700 line-height-2">Conductores</span>
            </p-button>
        </div>

        <div class="lg:w-auto w-6 px-2 py-2">
            <p-button styleClass="p-button-outlined p-button-danger  w-full flex justify-content-center" (onClick)="selecApp(config.data.loginTaxi)">
                <span class="text-2xl text-700 line-height-2">Taxis</span>
            </p-button>
        </div>
       
        
    </div>